import * as yup from 'yup';

export const DeviceSchema = yup.object().shape({
  name: yup.string().required('Name should be required and unique across store'),
  description: yup.string().required('Description is required')
});
